type Tab = 'chat' | 'skills';

type Props = {
  tab: Tab | string;
  open: boolean;
  onTab: (tab: Tab) => void;
  onToggle: () => void;
};

export default function ComposeRail({ tab, open, onTab, onToggle }: Props) {
  const activate = (next: Tab) => {
    if (!open) {
      onTab(next);
      onToggle();
      return;
    }
    if (next === tab) {
      onToggle();
      return;
    }
    onTab(next);
  };

  return (
    <nav className="w-14 shrink-0 border-r border-border bg-surface flex flex-col items-center py-3 gap-2" data-testid="compose-rail">
      <button
        type="button"
        data-testid="rail-chat"
        aria-pressed={tab === 'chat'}
        onClick={() => activate('chat')}
        className={`w-10 h-10 rounded-lg flex items-center justify-center ${tab === 'chat' && open ? 'bg-accentSoft text-accent' : 'text-texts hover:text-textp hover:bg-surface2'}`}
        title="Chat"
      >
        <i className="ri-chat-3-line text-lg" />
      </button>
      <button
        type="button"
        data-testid="rail-skills"
        aria-pressed={tab === 'skills'}
        onClick={() => activate('skills')}
        className={`w-10 h-10 rounded-lg flex items-center justify-center ${tab === 'skills' && open ? 'bg-accentSoft text-accent' : 'text-texts hover:text-textp hover:bg-surface2'}`}
        title="Skills"
      >
        <i className="ri-stack-line text-lg" />
      </button>
    </nav>
  );
}
